/**
 * SF-181 Component 5: named constant for `useMobileTabBarPresent`/`ToastContainer`'s tab-bar
 * reserve, matching `Layout.tsx`/`AppShellLayout.tsx`'s existing 96px reserve for
 * `MobileTabBar`'s footprint (SF-132 Decision 4). Deliberately NOT a shared refactor of the 6
 * other pre-existing local `96px` literals (`Layout.tsx`, `AppShellLayout.tsx`,
 * `MobileRazePanel.tsx`, `MobileBuildingsShell.tsx`, `MobileTrainingShell.tsx`,
 * `MobileSciencesShell.tsx`, `ResourceBarSheet.tsx`) — out of scope for this spec.
 */
export const MOBILE_TAB_BAR_RESERVE_PX = 96;
